const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`2dda6d270639bc88a47760d29175b15c3c039b9828f9256573d35b703d160438`, `2dda6d270639bc88a47760d29175b15c3c039b9828f9256573d35b703d160438`, 1, 130), undefined, true, false, 1));
            }

            getTemplateName() {
                return `2dda6d270639bc88a47760d29175b15c3c039b9828f9256573d35b703d160438`;
            }

            getSourceContext() {
                return new this.Source(``, `2dda6d270639bc88a47760d29175b15c3c039b9828f9256573d35b703d160438`, ``);
            }
        }],
        [130, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/button-group/button-group.twig`, `2dda6d270639bc88a47760d29175b15c3c039b9828f9256573d35b703d160438`, 1);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/button-group/button-group.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/button/button.twig`, new Map([[`label`, `Default`]]), true, false, 3));
                this.echo(`    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/button/button.twig`, new Map([[`label`, `Secondary`], [`class`, `c-button--secondary`]]), true, false, 4));
                this.echo(`    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/button/button.twig`, new Map([[`label`, `Tertiary`], [`class`, `c-button--tertiary`]]), true, false, 5));
                this.echo(`  `);
            }

            getTemplateName() {
                return `2dda6d270639bc88a47760d29175b15c3c039b9828f9256573d35b703d160438`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `2dda6d270639bc88a47760d29175b15c3c039b9828f9256573d35b703d160438`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '2dda6d270639bc88a47760d29175b15c3c039b9828f9256573d35b703d160438');

let template = env.loadTemplate('2dda6d270639bc88a47760d29175b15c3c039b9828f9256573d35b703d160438');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/button/demo/styles.twig", args: context }
     );
     return rendered;;
};